import { useState } from "react";
import ImageControls from "../ImageControls";
import { Button, Grid } from "@mui/material";
import getStyles from "../UserModal/styles";
import IImages from "../../types/images";

interface IImagesProps {
  images: IImages;
  imgSize: number;
  imgHeight: number;
  // showContraols: string;
  imgControl: boolean;
}
export default function Images(props: IImagesProps) {
  const { images, imgSize, imgHeight, imgControl } = props;
  const [isFlipped, setIsFlipped] = useState(false);

  const handleFlipDocument = () => setIsFlipped(!isFlipped);
  const styles = getStyles();

  return (
    <Grid container sx={{}}>
      <Grid item xs={imgSize} xl={imgSize}>
        <ImageControls
          imgHeight={imgHeight}
          image={`data:image/jpeg;base64,${images.selfie}`}
          imgControl={imgControl}
        />
      </Grid>
      {images.selfieRef ? (
        <Grid item xs={imgSize} xl={imgSize}>
          <ImageControls
            imgHeight={imgHeight}
            image={`data:image/jpeg;base64,${images.selfieRef}`}
            imgControl={imgControl}
          />
        </Grid>
      ) : null}
      {images.document ? (
        <Grid item xs={imgSize} xl={imgSize}>
          <ImageControls
            imgHeight={imgHeight}
            imgControl={imgControl}
            image={`data:image/jpeg;base64,${isFlipped ? images.documentBack : images.document}`}
          />
          {images.documentBack && imgControl ? (
            <Button onClick={handleFlipDocument} variant="contained" sx={styles.flipButton}>
              Show other file
            </Button>
          ) : null}
        </Grid>
      ) : null}
    </Grid>
  );
}
